const PrivacyAndSecurity = () => (
  <>
    <div style={{ padding: 30 }}>
      <div>
        <br />
      </div>
      <b>GİZLİLİK VE GÜVENLİK POLİTİKASI</b>
    </div>
  </>
);

export default PrivacyAndSecurity;
